import { render, staticRenderFns } from "./ClientSearch.vue?vue&type=template&id=4d50f2a7&scoped=true"
import script from "./ClientSearch.vue?vue&type=script&lang=js"
export * from "./ClientSearch.vue?vue&type=script&lang=js"
import style0 from "./ClientSearch.vue?vue&type=style&index=0&id=4d50f2a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d50f2a7",
  null
  
)

export default component.exports